import { zodResolver } from '@hookform/resolvers/zod'
import React from 'react'
import { type FieldValues, type UseFormReturn, useForm } from 'react-hook-form'
import * as z from 'zod'
import { ArrowForwardIcon } from '~/@mid_ui/icons/ArrowForwardIcon'
import { Button } from '~/shadcn/ui/button/button'
import { Form } from '~/shadcn/ui/form/form'

type InferFormValues<TSchema extends z.ZodType<any, any, any>> =
  z.infer<TSchema> & FieldValues

type StepProps<TSchema extends z.ZodType<any, any, any>> = {
  defaultValues: z.infer<TSchema>
  schema: TSchema
  onStepCompleted(data: z.infer<TSchema>): void
  render(methods: UseFormReturn<InferFormValues<TSchema>>): React.ReactNode
}

export function FormStep<TSchema extends z.ZodType<any, any, any>>({
  defaultValues,
  schema,
  onStepCompleted,
  render,
}: StepProps<TSchema>) {
  const form = useForm<InferFormValues<TSchema>>({
    resolver: zodResolver(schema) as any,
    defaultValues: defaultValues as InferFormValues<TSchema>,
  })

  return (
    <>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onStepCompleted as any)}>
          <div className="flex flex-col gap-10">
            {render(form)}
            <Button
              variant="accent"
              className="md:w-fit"
              size="2xl"
              disabled={!!Object.keys(form?.formState?.errors).length}
              onClick={() => window.scrollTo(0, 0)}
              type="submit">
              Potvrdiť
              <ArrowForwardIcon className="ml-2" />
            </Button>
          </div>
        </form>
      </Form>
    </>
  )
}
